import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "categorySelect",
    "sourceSelect",
    "contactSelect",
    "contactGroup",
    "paymentModalityInfo",
    "commissionInfo",
    "paymentsSection"
  ]

  connect() {
    if (this.hasSourceSelectTarget) {
      // Guardar las opciones originales del select de medios para poder filtrarlas
      this.sourceOptions = Array.from(this.sourceSelectTarget.options)
      
      this.filterSources()
      this.updateSourceDetails()
    }
  }

  // Se ejecuta al cambiar la categoría comercial
  filterSources() {
    if (!this.hasCategorySelectTarget || !this.hasSourceSelectTarget) return

    const category = this.categorySelectTarget.value
    const currentSelectedValue = this.sourceSelectTarget.value

    // Limpiar select de medios
    this.sourceSelectTarget.innerHTML = ""

    // Agregar el placeholder
    const placeholder = document.createElement("option")
    placeholder.value = ""
    placeholder.text = "Seleccione un medio..."
    this.sourceSelectTarget.add(placeholder)

    // Filtrar y agregar las opciones que coinciden con la categoría
    const matchedOptions = this.sourceOptions.filter(opt => opt.dataset.category === category)
    matchedOptions.forEach(opt => {
      // Clonamos para no alterar el original
      const clone = opt.cloneNode(true)
      this.sourceSelectTarget.add(clone)
    })

    // Si había una seleccionada y sigue estando disponible, la volvemos a seleccionar
    if (category && matchedOptions.some(opt => opt.value === currentSelectedValue)) {
      this.sourceSelectTarget.value = currentSelectedValue
    } else if (matchedOptions.length === 1) {
      // Si solo hay un medio para esta categoría (ej. cliente antiguo, referido), lo seleccionamos automáticamente
      this.sourceSelectTarget.value = matchedOptions[0].value
    }

    this.updateSourceDetails()
  }

  // Se ejecuta al cambiar el medio de adquisición
  updateSourceDetails() {
    if (!this.hasSourceSelectTarget) return

    const selectedOption = this.sourceSelectTarget.selectedOptions[0]
    
    if (!selectedOption || !selectedOption.value) {
      // Resetear vista si no hay medio seleccionado
      if (this.hasContactGroupTarget) this.contactGroupTarget.classList.add("hidden")
      if (this.hasContactSelectTarget) {
        this.contactSelectTarget.innerHTML = "<option value=''>Seleccione asesor o sede...</option>"
      }
      if (this.hasPaymentModalityInfoTarget) this.paymentModalityInfoTarget.textContent = "-"
      if (this.hasCommissionInfoTarget) this.commissionInfoTarget.textContent = "-"
      this.toggleCommissionFields(false)
      this.togglePaymentsSection(true) // Por defecto mostramos pagos
      return
    }

    const billingModality = selectedOption.dataset.billingModality
    const commissionScheme = selectedOption.dataset.commissionScheme
    const requiresSubAdvisors = selectedOption.dataset.requiresSubAdvisors === "true"
    const paysCommission = commissionScheme !== "no_commission"
    const contactsJson = selectedOption.dataset.contacts ? JSON.parse(selectedOption.dataset.contacts) : []

    // 1. Mostrar información comercial/financiera del canal
    const modalityLabels = {
      direct: "Cobro Directo",
      entity_invoiced: "Factura a Entidad",
      entity_deferred: "Crédito a Entidad"
    }
    if (this.hasPaymentModalityInfoTarget) {
      this.paymentModalityInfoTarget.textContent = modalityLabels[billingModality] || billingModality
    }
    if (this.hasCommissionInfoTarget) {
      this.commissionInfoTarget.textContent = paysCommission ? "Con comisión" : "Sin comisión"
    }

    // 2. Controlar la sección de Pagos (solo obligatorio si es Cobro Directo)
    this.togglePaymentsSection(billingModality === "direct")

    // 3. Cargar y controlar asesores externos
    if (this.hasContactSelectTarget) {
      this.contactSelectTarget.innerHTML = "<option value=''>Seleccione asesor o sede...</option>"

      if (contactsJson.length > 0) {
        contactsJson.forEach(c => {
          const opt = document.createElement("option")
          opt.value = c.id
          opt.text = `${c.name} ${c.phone ? `(${c.phone})` : ''}`
          
          // Volver a seleccionar si ya estaba guardado en base de datos
          if (this.contactSelectTarget.dataset.selectedId == c.id) {
            opt.selected = true
          }
          this.contactSelectTarget.add(opt)
        })
        if (this.hasContactGroupTarget) this.contactGroupTarget.classList.remove("hidden")
      } else {
        if (this.hasContactGroupTarget) this.contactGroupTarget.classList.add("hidden")
      }

      // Si se configuró explícitamente que requiere subasesor, aseguremos que se muestre (aunque la DB esté vacía por error)
      if (requiresSubAdvisors && this.hasContactGroupTarget) {
        this.contactGroupTarget.classList.remove("hidden")
      }
    }

    // 4. Mostrar u ocultar campos de comisión en los detalles de vehículo
    this.toggleCommissionFields(paysCommission)
  }

  toggleCommissionFields(show) {
    document.querySelectorAll(".commission-field-wrapper").forEach(el => {
      if (show) {
        el.classList.remove("hidden")
      } else {
        el.classList.add("hidden")
        // Opcional: resetear a 0.00 si se oculta
        const input = el.querySelector("input")
        if (input && !input.value) input.value = "0.00"
      }
    })
  }

  togglePaymentsSection(show) {
    if (this.hasPaymentsSectionTarget) {
      if (show) {
        this.paymentsSectionTarget.classList.remove("hidden")
      } else {
        this.paymentsSectionTarget.classList.add("hidden")
      }
    }
  }
}

